module.exports = __webpack_public_path__ + "static/media/om_hairstyle_wavy_back.88440af7.png";